import { useLanguage } from '../contexts/LanguageContext';

/**
 * Hook personnalisé pour faciliter l'utilisation des traductions
 * @returns {Function} Fonction t pour traduire les clés
 * 
 * @example
 * const { t } = useTranslation();
 * <h1>{t('dashboard.title')}</h1>
 * <p>{t('common.loading')}</p>
 */
export const useTranslation = () => {
  const { t } = useLanguage();
  return { t };
};

export default useTranslation;
